<template>
  <div class="d-flex align-center justify-space-between" style="height: 50px">
    <div class="d-flex align-center">
      <div class="d-flex" style="width: 200px">
        <div style="width: 120px">{{ kind === 'cen' ? 'Học phí:' : 'Chuyên đề:' }}</div>
        <div>
          {{ get(item[kind], 'amountDebt', 0).toLocaleString('en-US') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
export default {
  components: {},
  data() {
    return { get }
  },
  props: {
    kind: String,
    item: Object,
  },
  methods: {},
}
</script>

<style></style>
